import React, { useState } from "react";
import { Box, Text, Button, Grid, Label, Flex, Modal, ErrorMsg } from "atoms";
import { FormInput } from "molecules";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import MemoClose from "assets/icons/Close";
import { InvitationSentModal } from "../InvitationSentModal";

const validationSchema = Yup.object().shape({
  role: Yup.string().required("Role is required"),
  // email: Yup.string().required("Email is required"),
  // password: Yup.string().required("Password is required"),
  // confirmPassword: Yup.string().required("Confirm Password is required"),
});

export const AddNewRoleModal = ({
  isOpen,
  onClose,
  preRole,
  onSubmit,
  loading,
  error,
  resetError,
}) => {
  const [isConfirmModalVisible, setConfirmModalVisible] = useState(false);

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <Box width={{ md: "48.8rem" }}>
          <Box p={{ xs: "2.4rem", lg: "3.2rem" }}>
            <Flex
              justifyContent="space-between"
              borderBottom="0.1rem solid"
              borderColor="neutral.100"
              pb="2.4rem"
            >
              <Text
                fontSize="2rem"
                color="primary.900"
                fontFamily="primaryBold"
              >
                {preRole ? "Edit" : "Add New"} Role
              </Text>
              <Box
                color="neutral.900"
                onClick={onClose}
                cursor="pointer"
                textAlign="right"
              >
                <MemoClose height="1.6rem" width="1.6rem" />
              </Box>
            </Flex>
            <Formik
              initialValues={{
                role: preRole?.name || "",
                // email: "",
                // password: "",
                // confirmPassword: "",
              }}
              onSubmit={onSubmit}
              validationSchema={validationSchema}
            >
              {({ values, setFieldValue }) => {
                return (
                  <Form>
                    <Grid gridRowGap="2.4rem" mt="1.8rem">
                      <Grid gridRowGap="1.6rem">
                        <Label text="Role" req />
                        <FormInput
                          name="role"
                          placeholder="Enter Role"
                          req
                          onChange={(e) => {
                            setFieldValue("role", e?.target?.value);
                            error && resetError();
                          }}
                        />
                      </Grid>
                      {error && <ErrorMsg text={error} />}
                      {/* <Grid gridRowGap="1.6rem">
                        <Label text="Project Name" req />
                        <FormInput name="email" type="email" placeholder="Enter Email" req />
                      </Grid>
                      <Grid gridRowGap="1.6rem">
                        <Label text="Password" req />
                        <FormInput
                          name="password"
                          type="password"
                          placeholder="Enter Password"
                          req
                        />
                      </Grid>
                      <Grid gridRowGap="1.6rem">
                        <Label text="Confirm Password" req />
                        <FormInput
                          name="confirmPassword"
                          type="password"
                          placeholder="Enter Confirm Password"
                          req
                        />
                      </Grid> */}

                      <Button
                        variant="primary"
                        type="submit"
                        height={{ xs: "4.3rem", lg: "4.8rem" }}
                        loading={loading}
                      >
                       Save
                      </Button>
                    </Grid>
                  </Form>
                );
              }}
            </Formik>
          </Box>
        </Box>
      </Modal>
      {isConfirmModalVisible && (
        <InvitationSentModal
          isOpen={isConfirmModalVisible}
          onClose={() => setConfirmModalVisible(false)}
        />
      )}
    </>
  );
};
